import { ReactNode } from 'react';
import { cn } from '../../utils';

type ContainerProps = {
    children?: ReactNode;
    padding?: boolean;
    className?: string;
};

export function FullWidthContainer({
    children,
    padding = true,
    className,
}: ContainerProps) {
    return (
        <div
            data-testid="FullWidthContainer"
            className={cn(
                'alli-h-full alli-min-h-[1000px] alli-overflow-hidden alli-bg-white',
                {
                    'alli-p-9': padding,
                },
                className,
            )}>
            {children}
        </div>
    );
}

export function PaddedFullWidthContainer({
    children,
    padding = true,
    className,
}: ContainerProps) {
    return (
        <div
            data-testid="PaddedFullWidthContainer"
            className="alli-mx-3 alli-my-2.5 alli-h-full">
            <div
                className={cn(
                    'alli-mx-auto alli-h-full alli-min-h-[1000px] alli-overflow-hidden alli-rounded-lg alli-border alli-border-gray-400 alli-bg-white',
                    {
                        'alli-px-8 alli-py-8': padding,
                    },
                    className,
                )}>
                {children}
            </div>
        </div>
    );
}

export function DefaultContainer({
    children,
    padding = true,
    className,
}: ContainerProps) {
    return (
        <div data-testid="DefaultContainer" className="alli-px-12 alli-py-2.5">
            <div
                className={cn(
                    'alli-mx-auto alli-h-full alli-min-h-[1000px] alli-max-w-[1700px] alli-overflow-hidden alli-rounded-lg alli-border alli-border-gray-400 alli-bg-white',
                    {
                        'alli-px-9 alli-py-6': padding,
                    },
                    className,
                )}>
                {children}
            </div>
        </div>
    );
}

export function DashboardsAppContainer({ children }: ContainerProps) {
    return (
        <div
            data-testid="DashboardsAppContainer"
            className="alli-mx-3 alli-my-2.5 alli-h-full">
            <div className="alli-mx-auto alli-h-full alli-min-h-[1000px] alli-rounded-lg alli-border alli-border-gray-400 alli-bg-white alli-px-8 alli-py-8">
                {children}
            </div>
        </div>
    );
}
